/* eslint-disable */
// WARNING: Review values according to env 
// TODO: check wich values apply
/*Dev*/
/*
const awsmobile = {
    "aws_appsync_graphqlEndpoint": "https://uwvv6ycgkfe2lgxaunv6edbcty.appsync-api.us-east-1.amazonaws.com/graphql",
};
*/
/* QA*/
/*
const awsmobile = {
    "aws_appsync_graphqlEndpoint": "https://aqptkbm3cneltglscyvuc2owr4.appsync-api.us-east-1.amazonaws.com/graphql",
};
*/

/* Stg*/

const awsmobile = {
    "aws_appsync_graphqlEndpoint": "https://4k5fkuaxvjdfxft664s2xgne2i.appsync-api.us-east-1.amazonaws.com/graphql",
};

/*Prod*/
/*
const awsmobile = {
    "aws_appsync_graphqlEndpoint": "https://bszzqaysqvcatmt7kvrjdhunqi.appsync-api.us-east-1.amazonaws.com/graphql",
};
*/
export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js